export const normalizeCapacityToKg = (capacity: number, unit: string): number | null => {
  switch (unit) {
    case 'tons':
      return capacity * 1000;
    case 'kg':
      return capacity;
    case 'liters':
      return null;
    default:
      return null;
  }
};

export const calculateFillRate = (
  fillLevelKg?: number,
  capacity?: number,
  capacityUnit?: string
): number | null => {
  if (fillLevelKg == null || capacity == null || !capacityUnit) return null;

  const capacityKg = normalizeCapacityToKg(capacity, capacityUnit);
  if (!capacityKg || capacityKg === 0) return null;

  return Math.min(Math.round((fillLevelKg / capacityKg) * 100), 100);
};
